import axios from '@api/axios';

const axiosInstance = axios.create({
    baseURL: `/api/sessions`
});

const index = function(paginatorOptions = null) {
    return axiosInstance.get('', {
        params: paginatorOptions
    });
};

export default { axios: axiosInstance, index };
